<div class="loading" *ngIf="isLoading">
  <mat-progress-bar
    class="loading__progress-bar"
    mode="indeterminate"
  ></mat-progress-bar>

  <div class="loading__container">
    {{ editedStore ? 'Editing' : 'Creating' }} store...
  </div>
</div>

<h2 mat-dialog-title class="title">
  {{ editedStore ? 'Edit' : 'Create' }} Store
</h2>

<h3 class="subtitle">
  Ensure your store information is accurate before saving.
</h3>

<mat-icon
  class="close-icon"
  aria-hidden="false"
  aria-label="close icon"
  iconPositionEnd
  mat-dialog-close
  >close</mat-icon
>

<mat-dialog-content>
  <form
    #form="ngForm"
    [formGroup]="createStoreForm"
    class="create-store-form"
    id="create-store-form"
    (ngSubmit)="onSubmit()"
  >
      <mat-form-field appearance="fill">
          <mat-label>Merchant</mat-label>
          <mat-select
                  formControlName="MerchantId"
                  [placeholder]="'Please Select Merchant'"
          >
              <mat-option
                      *ngFor="let merchant of merchantsList"
                      [value]="merchant.Id"
              >{{ merchant.Name }}</mat-option
              >
          </mat-select>
          <mat-error *ngIf="createStoreForm.get('MerchantId')?.hasError('required')"
          >This field is required.</mat-error
          >
      </mat-form-field>

      <span class="ml-3">
          <div>Store Type</div>
          <mat-radio-group formControlName="StoreType">
              <mat-radio-button color="primary" [value]="1">Eats</mat-radio-button>
              <mat-radio-button color="primary" [value]="2">Mart</mat-radio-button>
          </mat-radio-group>
      </span>

    <mat-form-field appearance="outline" class="street-address-input">
      <mat-label>Street Address</mat-label>
      <input
        type="text"
        matInput
        formControlName="Address"
        [matAutocomplete]="streetAuto"
      />
      <mat-autocomplete
        #streetAuto="matAutocomplete"
        (optionSelected)="onOptionSelected($event)"
        [displayWith]="displayFn"
      >
        <mat-option
          *ngFor="let option of filteredOptions$ | async"
          [value]="option"
        >
          {{ option.description }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="createStoreForm.get('Address')?.hasError('required')"
        >This field is required.</mat-error
      >
      <mat-error *ngIf="createStoreForm.get('Address')?.hasError('isDuplicate')"
        >This location already exists in your store list.</mat-error
      >
    </mat-form-field>

    <div
      #mapContainer
      class="map"
      [ngStyle]="{
        height: createStoreForm.get('Address')?.invalid ? '0' : '15rem'
      }"
    ></div>

      <mat-form-field *ngIf="createStoreForm.get('Address')?.valid" appearance="outline">
          <mat-label>Serviceable Area (KM Radius)</mat-label>
          <input matInput type="number" formControlName="Radius" />
          <mat-error *ngIf="createStoreForm.get('Radius')?.hasError('required')">
              This field is required.
          </mat-error>
      </mat-form-field>

    <h3 class="location-details-header">Location Details</h3>

      <mat-form-field>
          <mat-label>Brand</mat-label>
          <input matInput placeholder="" formControlName="Brand" />
      </mat-form-field>

    <mat-form-field>
      <mat-label>Location Name</mat-label>
      <input matInput placeholder="(ex: Uptown Mall)" formControlName="Name" />
      <mat-error *ngIf="createStoreForm.get('Name')?.invalid"
        >This field is required.</mat-error
      >
    </mat-form-field>

    <mat-form-field>
      <mat-label>Location Type</mat-label>
      <mat-select
        formControlName="LocationTypeId"
        [placeholder]="'(ex: ' + locationTypeList[0].name + ')'"
      >
        <mat-option
          *ngFor="let type of locationTypeList"
          [value]="type.value"
          >{{ type.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="createStoreForm.get('LocationTypeId')?.invalid"
        >This field is required.</mat-error
      >
    </mat-form-field>

    <mat-form-field>
      <mat-label>Additional Details</mat-label>
      <input
        matInput
        placeholder="(ex: 3rd Floor)"
        formControlName="AddressDetails"
      />
      <mat-error *ngIf="createStoreForm.get('AddressDetails')?.invalid"
        >This field is required.</mat-error
      >
    </mat-form-field>

      <mat-form-field>
          <mat-label>City</mat-label>
          <input matInput placeholder="" formControlName="City" />
      </mat-form-field>

      <mat-form-field>
          <mat-label>Postal Code</mat-label>
          <input matInput placeholder="" formControlName="PostalCode" />
      </mat-form-field>

    <h3 class="location-photos-header">Location Photo (not published)</h3>

    <ng-container
      *ngIf="!createStoreForm.get('ImageUrl')?.value; else filename"
    >
      <div
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event)"
        class="upload"
        [ngClass]="{
          'upload-error':
            createStoreForm.get('ImageUrl')?.invalid && form.submitted
        }"
      >
        <p class="upload__hint">Drop files here to upload</p>

        <input
          type="file"
          class="upload__file-input"
          (change)="onFileSelected($event)"
          #fileUpload
        />

        <button
          mat-button
          type="button"
          class="light-button"
          (click)="fileUpload.click()"
        >
          Browse file
        </button>
      </div>

      <p class="upload-error-message" *ngIf="form.submitted">
        <ng-container *ngIf="createStoreForm.get('locationPhotoFile')?.invalid">
          This is required.
        </ng-container>
      </p>

      <p class="upload-error-message">
        <ng-container *ngIf="locationPhotoFile?.hasError('filesize')">
          {{ locationPhotoFile?.errors?.['filesize'] }}
        </ng-container>

        <ng-container *ngIf="locationPhotoFile?.hasError('fileType')">
          {{ locationPhotoFile?.errors?.['fileType'] }}
        </ng-container>
      </p>
    </ng-container>

    <ng-template #filename>
      <mat-chip-set aria-label="Filename text" class="filename-chip">
        <mat-chip>
          {{ photoFilename }}
          <button
            (click)="removeLocationPhoto()"
            matChipRemove
            aria-label="Remove file"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-set>
    </ng-template>

      <mat-form-field>
          <mat-label>Store Email Address</mat-label>
          <input matInput placeholder="Store Email Address" formControlName="Email" required />
          <mat-error *ngIf="createStoreForm.get('Email')?.hasError('required')">
              Store email address is required.
          </mat-error>
          <mat-error *ngIf="createStoreForm.get('Email')?.touched && createStoreForm.get('Email')?.hasError('email')">
              Please enter a valid email address.
          </mat-error>
      </mat-form-field>

      <mat-form-field>
          <mat-label>Store Phone Number</mat-label>
          <input matInput placeholder="Store Phone Number" formControlName="Phone" required />
          <mat-error *ngIf="createStoreForm.get('Phone')?.hasError('required')">
              Store phone number is required.
          </mat-error>
          <mat-error *ngIf="createStoreForm.get('Phone')?.touched && createStoreForm.get('Phone')?.hasError('pattern')">
              Please enter a valid PH mobile number (e.g +639123456789).
          </mat-error>
      </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>

  <button
    type="submit"
    mat-flat-button
    color="primary"
    form="create-store-form"
    cdkFocusInitial
    [disabled]="form.invalid || !form.dirty"
  >
    Confirm
  </button>
</mat-dialog-actions>
